import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Module-level cache so every Radar page / panel shares one request.
let _cache = null;
let _inflight = null;

export async function fetchSyncMode(force = false) {
    if (_cache && !force) return _cache;
    if (!_inflight) {
        _inflight = api.get("/admin/sync/mode")
            .then((r) => { _cache = r.data; return _cache; })
            .catch(() => { _cache = { mode: "standalone", spoke: false }; return _cache; })
            .finally(() => { _inflight = null; });
    }
    return _inflight;
}

/** Sync mode of this deployment: `{mode, spoke, has_hub_link, hub_url, env_name, channel, last_sync_at, lag, bootstrap, in_sync}`. */
export function useSyncMode() {
    const [info, setInfo] = useState(_cache);
    const refresh = useCallback(() => fetchSyncMode(true).then(setInfo), []);
    useEffect(() => {
        let alive = true;
        fetchSyncMode().then((d) => { if (alive) setInfo(d); });
        return () => { alive = false; };
    }, []);
    return { info, loading: info == null, refresh };
}
